<form-input-regex
  id="txtLetters"
  [(ngModel)]="value"
  (ngModelChange)="onChange()"
  #input="ngModel"
  [regex]="regexLetters"
  [label]="label"
  [required]="required"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [hasError]="hasError"
></form-input-regex>
